function defaultPlaylistOpen() {
    if (typeof window === 'undefined') {
        return true;
    }
    return window.innerWidth > 900;
}

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        data:'',
        videos:[],
        user:'',
        player:'',
        videoIndex:0,
        currentVideoId:qk_global.post_id, //当前播放视频id
        post_id:qk_global.post_id,
        url:'',
        videoList:[],
        allowList:[],
        listStyle:'',
        preview:false,
        playlistOpen:defaultPlaylistOpen(),
    },
    mounted(){
        if(!document.getElementById('moeplayer')) return
        this.listStyle =  JSON.parse(localStorage.getItem('videoListStyle')) || false;

        try {
            const savedOpen = localStorage.getItem('videoPlaylistOpen');
            if (savedOpen !== null) {
                this.playlistOpen = savedOpen === '1';
            } else {
                this.playlistOpen = defaultPlaylistOpen();
            }
        } catch (e) {
            this.playlistOpen = defaultPlaylistOpen();
        }

        this.$http.post(qk_rest_url+'getVideoList','post_id='+this.post_id).then(res=>{
            this.data = res.data;
            this.videos = res.data.list;
            this.videoList = this.convertDataToVideoList(this.videos);
            this.user = res.data.current_user
            this.allowList = this.user.allowList
            this.videoIndex = this.videoList.findIndex((item) => {
                return item.id == this.post_id;
            })
            
            if(this.videoList.length) {
                if(this.allowList[this.videoIndex] == true){
                    
                    this.player = new MoePlayer({
                        container: document.getElementById('moeplayer'),
                        autoplay:true,
                        autonext:true,
                        theme:"var(--theme-color)",
                        videoList:this.videoList,
                        videoIndex:this.videoIndex,
                        danmaku: {
                            id: qk_global.post_id,
                            sendApi: qk_rest_url + 'sendDanmaku',
                            getApi: qk_rest_url + 'getDanmaku',
                        },
                    });
                    
                    this.player.on('switchVideo', (i)=>{
                        this.videoIndex = i
                        
                        this.currentVideoId = this.videoList[this.videoIndex].id
                        // 更新浏览器地址
                        //window.history.pushState(null, '', this.videoList[this.videoIndex].link);
                        qkCurrentPageReload(this.videoList[this.videoIndex].link);
                    })
                    
                    this.player.on('next', (i)=>{
                        // this.videoIndex = i
                        // this.currentVideoId = this.videoList[this.videoIndex].id
                        
                        qkCurrentPageReload(this.videoList[i].link);
                    })
                    
                    if(this.user.free_video) {
                         this.player.toast.add(`
                            <div class="title">您正在享受会员免费观看视频特权</div>
                            <div class="desc">今日剩余免费观看 `+(this.user.free_count >= 9999 ? '不限' : this.user.free_count)+` 次</div>`
                        ,10000)
                    }
                    
                //试看
                }else if(this.videoList[this.videoIndex].preview_url){
                    
                    this.preview = true;
                    
                    this.player = new MoePlayer({
                        container: document.getElementById('moeplayer'),
                        autoplay:true,
                        autonext:false,
                        theme:"var(--theme-color)",
                        video:this.videoList[this.videoIndex],
                        danmaku: {
                            id: qk_global.post_id,
                            sendApi: qk_rest_url + 'sendDanmaku',
                            getApi: qk_rest_url + 'getDanmaku',
                        },
                    });
                    
                    this.player.on('ended', (i)=>{
                        this.preview = false;
                    })
                    
                    this.player.toast.add(`
                    <div class="prompt-bar-container">
                        <div>
                            <div class="title">本片是限制内容</div>
                            <div class="desc">试看中 · <span onclick="createModal('vip',{size:720})" style=" cursor: pointer; ">成为会员</span> 免费看本片</div>
                        </div>
                        <div class="action-wrap">
                            <div class="button" onclick="episodePlayerWrap.changePreview()">完整观看</div>
                        </div>
                    </div>
                    `
                    ,9e6)
                }
            }
        }).catch((err) => {
            qkShowApiError(err, '加载视频失败');
        })

    },
    methods:{
        switchVideo(video){
            
            //if(this.currentVideoId == video.id) return;
            
            // this.videoIndex = this.videoList.findIndex((item) => {
            //     return item.url == video.url;
            // })

            //this.currentVideoId = video.id;
            
            qkCurrentPageReload(video.link);
            
            // this.player.switchVideo({ 
            //     url:video.url,
            //     pic:video.thumb,
            //     title:video.title,
            // });
            
        },
        playAtIndex(index) {
            const video = this.videoList[index];
            if (!video?.link) return;
            qkCurrentPageReload(video.link);
        },
        getFlatIndex(chapterIndex, itemVideoIndex) {
            let flat = 0;
            for (let i = 0; i < chapterIndex; i++) {
                if (this.videos[i] && Array.isArray(this.videos[i].video_list)) {
                    flat += this.videos[i].video_list.length;
                }
            }
            return flat + itemVideoIndex;
        },
        pay(allpay) {
            if(!qktoken && this.allowList[this.videoIndex] == false && !this.user.not_login_pay && this.user.type == 'money'){
                this.login();
            }else if(this.allowList[this.videoIndex] == false){
                if(this.user.type == 'credit' || this.user.type == 'money'){
                    if(!allpay) {
                        qkpay({
                            'title': this.videoList[this.videoIndex].title,
                            'order_price': this.user.value,
                            'order_type':'video',
                            'order_key':this.videoIndex,
                            'post_id':this.data.id,
                            'chapter_id':this.post_id,
                            'type':this.user.type,
                            'tag':'付费视频'
                        },this.user.type)
                    }else{
                        qkpay({
                            'title': this.data.title,
                            'order_price': this.user.total_value,
                            'order_type':'video',
                            'post_id':this.data.id,
                            'type':this.user.type,
                            'tag':'付费视频'
                        },this.user.type)
                    }
                    
                }else if(this.user.type == 'password') {
                    this.$createModal('passwordVerify',{
                        size:312,
                        loading:false,
                        props:{
                            data:qk_global.password_verify
                        },
                    })
                }else{
                    this.$message({ message: '您无权观看，请升级权限！' , type: 'warning' });
                }
                return 
            }
        },
        login(){
            if(!qktoken) return this.$createModal('login');
        },
        changeListStyle() {
            this.listStyle = !this.listStyle;
            localStorage.setItem('videoListStyle', this.listStyle);
        },
        togglePlaylistDrawer() {
            this.playlistOpen = !this.playlistOpen;
            try {
                localStorage.setItem('videoPlaylistOpen', this.playlistOpen ? '1' : '0');
            } catch (e) {
                /* ignore */
            }
        },
        changePreview() {
            this.preview = false;
            this.player.pause();
        },
        getEpisodeNumber(chapterIndex, videoIndex) {
            let episodeNumber = 1;
            for (let i = 0; i < chapterIndex; i++) {
                episodeNumber += this.videos[i].video_list.length;
            }
            episodeNumber += videoIndex;
            return episodeNumber;
        },
        convertDataToVideoList(data) {
            let videoList = [];
            
            // 检查数据是否存在以及是否为数组
            if (data && Array.isArray(data)) {
                data.forEach(item => {
                    // 检查章节数据是否存在以及是否为数组
                    if (item && item.video_list && Array.isArray(item.video_list)) {
                        item.video_list.forEach(video => {
                            videoList.push({
                                id: video.id,
                                url: video.url ? video.url : video.preview_url,
                                preview_url:video.preview_url,
                                pic: video.pic,
                                title: video.title,
                                link:video.link
                            });
                        });
                    }
                });
            }
            
            return videoList;
        }
    }
};
